// Package export has no .css in the specifier (vuetify/styles → main.css)
// eslint-disable-next-line import/extensions
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/lib/iconsets/mdi';
import { ar, de, el, en, ru } from 'vuetify/lib/locale';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
import translateService from '@/services/translate';

const currentLocale = (translateService.getDefaultLanguage() || 'en').toLowerCase();

// Per https://v3.vuetifyjs.com/en/getting-started/upgrade-guide/
export default createVuetify({
  components: {
    VTreeview,
  },
  defaults: {
    VBtn: {
      variant: 'flat',
      size: 'large',
    },
    VCardActions: {
      VBtn: {
        variant: 'flat',
        size: 'large',
      },
    },
    VMenu: {
      openDelay: 0,
      closeDelay: 0,
    },
    VTextField: {
      variant: 'underlined',
      color: 'primary',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'underlined',
      color: 'primary',
      density: 'comfortable',
    },
    VAutocomplete: {
      variant: 'underlined',
      density: 'comfortable',
      color: 'primary',
    },
    VTextarea: {
      variant: 'underlined',
      color: 'primary',
    },
    VCheckbox: {
      color: 'primary',
      density: 'compact',
    },
    VCheckboxBtn: {
      color: 'primary',
      density: 'compact',
    },
  },
  display: {
    mobileBreakpoint: 1400,
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1600,
      xl: 1904,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        variables: {
          'body-font-family': 'Roboto, sans-serif',
        },
        colors: {
          primary: '#1829D0',
          secondary: '#E6EBFF',
          'on-secondary': '#1e1e22',
          info: '#E6EBFF',
          'on-info': '#1829D0',
          error: '#ff5252',
          blue: '#00008D',
          blue20: '#002fff',
          blue40: '#4167f0',
          blue50: '#C7D6FF',
          blue70: '#8097ff',
          progress: '#99acff',
          grey: '#757575',
          'on-surface': '#1e1e22',
        },
      },
    },
  },
  locale: {
    locale: currentLocale,
    fallback: 'en',
    messages: { ar, de, el, en, ru },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      sort: 'mdi-arrow-down',
    },
    sets: {
      mdi,
    },
  },
});
